import Vue from 'vue'
import App from './App.vue'

import router from './routers/session';
import store from './store/store';

import * as Sentry from '@sentry/vue';
import sentryConfig from '@/config/Sentry';
Sentry.init({
  Vue: Vue,
  ...sentryConfig
});

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#sessionApp')
